import px2rem from '../../../utils/px2rem'
import { BASE_FONT_SIZE_NUMBER } from './typography'

const rem = (px: number) => px2rem(px, BASE_FONT_SIZE_NUMBER)

export const space = {
  dp1: '1px',
  dp2: rem(2),
  dp4: rem(4),
  dp8: rem(8),
  dp12: rem(12),
  dp16: rem(16),
  dp24: rem(24),
  dp28: rem(28),
  dp32: rem(32),
}

export const letterSpacing = '0.03rem'
